/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for CreditNote controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetCreditNoteByIdResponse, UpdateCreditNoteRequest, GetOutgoingCreditNotesResponse, GetIncomingCreditNotesResponse, CreditNoteStateId, GetCreditNoteResponse, CreateCreditNoteRequest, CreateCreditNoteResponse, GetCreditNoteAccountingOperationsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class CreditNoteService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getCreditNoteById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCreditNoteByIdResponse>;
    getCreditNoteById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCreditNoteByIdResponse>>;
    getCreditNoteById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCreditNoteByIdResponse>>;
    getCreditNoteById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CreditNote/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateCreditNote(id: number, updateCreditNoteRequest: UpdateCreditNoteRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateCreditNote(id: number, updateCreditNoteRequest: UpdateCreditNoteRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateCreditNote(id: number, updateCreditNoteRequest: UpdateCreditNoteRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateCreditNote(id: number, updateCreditNoteRequest: UpdateCreditNoteRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CreditNote/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateCreditNoteRequest, requestOptions);
    }

    deleteCreditNote(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteCreditNote(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteCreditNote(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteCreditNote(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CreditNote/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    sendCreditNote(id: number, to: Array<string>, cc: Array<string>, bcc: Array<string>, object: string, content: string, attachments?: (Array<Blob> | null), observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    sendCreditNote(id: number, to: Array<string>, cc: Array<string>, bcc: Array<string>, object: string, content: string, attachments?: (Array<Blob> | null), observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    sendCreditNote(id: number, to: Array<string>, cc: Array<string>, bcc: Array<string>, object: string, content: string, attachments?: (Array<Blob> | null), observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    sendCreditNote(id: number, to: Array<string>, cc: Array<string>, bcc: Array<string>, object: string, content: string, attachments?: (Array<Blob> | null), observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CreditNote/${id}/send`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (to !== undefined && Array.isArray(to)) {
            to.forEach((item) => {
                if (item !== undefined && item !== null) {
                    formData.append('to', String(item));
                }
            });
        }
        if (cc !== undefined && Array.isArray(cc)) {
            cc.forEach((item) => {
                if (item !== undefined && item !== null) {
                    formData.append('cc', String(item));
                }
            });
        }
        if (bcc !== undefined && Array.isArray(bcc)) {
            bcc.forEach((item) => {
                if (item !== undefined && item !== null) {
                    formData.append('bcc', String(item));
                }
            });
        }
        if (object !== undefined) {
            formData.append('object', String(object));
        }
        if (content !== undefined) {
            formData.append('content', String(content));
        }
        if (attachments !== undefined && Array.isArray(attachments)) {
            attachments.forEach((item) => {
                if (item !== undefined && item !== null) {
                    formData.append('attachments', item);
                }
            });
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, formData, requestOptions);
    }

    getOutgoingCreditNotes(startDate: Date, endDate: Date, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetOutgoingCreditNotesResponse>;
    getOutgoingCreditNotes(startDate: Date, endDate: Date, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetOutgoingCreditNotesResponse>>;
    getOutgoingCreditNotes(startDate: Date, endDate: Date, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetOutgoingCreditNotesResponse>>;
    getOutgoingCreditNotes(startDate: Date, endDate: Date, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CreditNote/Outgoing`;

        let params = new HttpParams();
        if (startDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, startDate, 'startDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getIncomingCreditNotes(startDate: Date, endDate: Date, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetIncomingCreditNotesResponse>;
    getIncomingCreditNotes(startDate: Date, endDate: Date, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetIncomingCreditNotesResponse>>;
    getIncomingCreditNotes(startDate: Date, endDate: Date, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetIncomingCreditNotesResponse>>;
    getIncomingCreditNotes(startDate: Date, endDate: Date, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CreditNote/Incoming`;

        let params = new HttpParams();
        if (startDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, startDate, 'startDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getCreditNotes(startDate: Date, endDate: Date, customerIds: Array<number>, stateNames: Array<CreditNoteStateId>, legalEntityIds: Array<number>, search?: string | null, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCreditNoteResponse>;
    getCreditNotes(startDate: Date, endDate: Date, customerIds: Array<number>, stateNames: Array<CreditNoteStateId>, legalEntityIds: Array<number>, search?: string | null, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCreditNoteResponse>>;
    getCreditNotes(startDate: Date, endDate: Date, customerIds: Array<number>, stateNames: Array<CreditNoteStateId>, legalEntityIds: Array<number>, search?: string | null, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCreditNoteResponse>>;
    getCreditNotes(startDate: Date, endDate: Date, customerIds: Array<number>, stateNames: Array<CreditNoteStateId>, legalEntityIds: Array<number>, search?: string | null, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CreditNote`;

        let params = new HttpParams();
        if (startDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, startDate, 'startDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }
        if (search != null) {
            params = HttpParamsBuilder.addToHttpParams(params, search, 'search');
        }
        if (customerIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, customerIds, 'customerIds');
        }
        if (stateNames != null) {
            params = HttpParamsBuilder.addToHttpParams(params, stateNames, 'stateNames');
        }
        if (legalEntityIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, legalEntityIds, 'legalEntityIds');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createCreditNote(createCreditNoteRequest: CreateCreditNoteRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateCreditNoteResponse>;
    createCreditNote(createCreditNoteRequest: CreateCreditNoteRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateCreditNoteResponse>>;
    createCreditNote(createCreditNoteRequest: CreateCreditNoteRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateCreditNoteResponse>>;
    createCreditNote(createCreditNoteRequest: CreateCreditNoteRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CreditNote`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createCreditNoteRequest, requestOptions);
    }

    getCreditNotesPeppolFile(uuids: Array<string>, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Blob>;
    getCreditNotesPeppolFile(uuids: Array<string>, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Blob>>;
    getCreditNotesPeppolFile(uuids: Array<string>, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Blob>>;
    getCreditNotesPeppolFile(uuids: Array<string>, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CreditNote/PeppolFile`;

        let params = new HttpParams();
        if (uuids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, uuids, 'uuids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            responseType: 'blob' as 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getCreditNotesAttachments(uuids: Array<string>, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Blob>;
    getCreditNotesAttachments(uuids: Array<string>, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Blob>>;
    getCreditNotesAttachments(uuids: Array<string>, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Blob>>;
    getCreditNotesAttachments(uuids: Array<string>, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CreditNote/Attachments`;

        let params = new HttpParams();
        if (uuids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, uuids, 'uuids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            responseType: 'blob' as 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getCreditNotePdf(id: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Blob>;
    getCreditNotePdf(id: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Blob>>;
    getCreditNotePdf(id: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Blob>>;
    getCreditNotePdf(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CreditNote/${id}/Pdf`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            responseType: 'blob' as 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getCreditNoteAccountingOperations(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCreditNoteAccountingOperationsResponse>;
    getCreditNoteAccountingOperations(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCreditNoteAccountingOperationsResponse>>;
    getCreditNoteAccountingOperations(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCreditNoteAccountingOperationsResponse>>;
    getCreditNoteAccountingOperations(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/CreditNote/${id}/AccountingOperations`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
